import * as actionTypes from '../types/correctionReadyProducts';

export function getReadyProducts(payload) {
  return {
    type: actionTypes.GET_READY_PRODUCTS,
    payload
  };
}

export function getReadyProductsSuccess(payload) {
  return {
    type: actionTypes.GET_READY_PRODUCTS_SUCCESS,
    payload
  };
}

export function getReadyProductsFail(payload) {
  return {
    type: actionTypes.GET_READY_PRODUCTS_FAIL,
    payload
  };
}

export function deleteReadyProducts(payload) {
  return {
    type: actionTypes.DELETE_READY_PRODUCTS,
    payload
  };
}

export function deleteReadyProductsSuccess(payload) {
  return {
    type: actionTypes.DELETE_READY_PRODUCTS_SUCCESS,
    payload
  };
}

export function deleteReadyProductsFail(payload) {
  return {
    type: actionTypes.DELETE_READY_PRODUCTS_FAIL,
    payload
  };
}

export function deleteReadyProductsMultiple(payload) {
  return {
    type: actionTypes.DELETE_READY_PRODUCTS_MULTIPLE,
    payload
  };
}

export function deleteReadyProductsMultipleSuccess(payload) {
  return {
    type: actionTypes.DELETE_READY_PRODUCTS_MULTIPLE_SUCCESS,
    payload
  };
}

export function deleteReadyProductsMultipleFail(payload) {
  return {
    type: actionTypes.DELETE_READY_PRODUCTS_MULTIPLE_FAIL,
    payload
  };
}

export function sendForMounting(payload) {
  return {
    type: actionTypes.SEND_FOR_MOUNTING,
    payload
  };
}

export function sendForMountingSuccess(payload) {
  return {
    type: actionTypes.SEND_FOR_MOUNTING_SUCCESS,
    payload
  };
}

export function sendForMountingFail(payload) {
  return {
    type: actionTypes.SEND_FOR_MOUNTING_FAIL,
    payload
  };
}
